module.exports = __webpack_public_path__ + "static/media/mirage-message-sent.09a36760.png";